/**
 * Route for `creative-hosting-inside-campaign`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { CreativeHostingInsideCampaignPage } from "../features/creative-hosting-inside-campaign/CreativeHostingInsideCampaignPage";

export const creativeHostingInsideCampaignRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/creative-hosting-inside-campaign",
	component: CreativeHostingInsideCampaignPage,
});

export default creativeHostingInsideCampaignRoute;
